<template>
  <div class="banner-plate">
    <el-carousel :interval="5000" arrow="always" height="100%">
      <!-- <el-carousel :interval="5000" arrow="hover" :height="bannerImgHeight + 'px'" > -->
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <div class="img-wrap">
          <img @click="handleBannerClick(item)" class="img" :src="item.bannerUrl" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
/**
 * list         轮播图列表
 * imgUrl       图片地址
 * autoHeight   true自适应高度  false固定高度
 */
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      bannerImgHeight: "", //轮播图高度
    };
  },
  methods: {
    //获取轮播图图片高度
    // getBannerImgHeight() {
    //     this.bannerImgHeight = window.document.querySelector('#bannerImg1').height
    // },
    handleBannerClick(item) {
      if (item.linkType == 1) {
        window.location.href = item.linkUrl;
      } else {
        window.open(item.linkUrl);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-plate {
  height: 1050px;

  .el-carousel {
    height: 100%;

    /deep/.el-carousel__container {
      height: 1050px;
    }

    .img-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      background-color: #fff;
      cursor: pointer;
    }
  }

  /deep/.el-carousel__arrow {
    width: 72px;
    height: 72px;
    font-size: 32px;
    line-height: 1 !important;
  }
}
</style>
